import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {IUserSettings} from "../Interfaces/UserSettings";
import {ITenantSettings} from "../Interfaces/ITenantSettings";

const getUserSettings = async (userId: string): Promise<IUserSettings> => {
    return new Promise<IUserSettings>((resolve, reject) => {
        return AxiosConfig.instance.get(`/usersettings/${userId}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}

const getTenantSettings = async (tenantId: string): Promise<ITenantSettings> => {
    return new Promise<ITenantSettings>((resolve, reject) => {
        return AxiosConfig.instance.get(`/usersettings/tenant/${tenantId}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}

const updateUserSettings = async (settings: IUserSettings): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        return AxiosConfig.instance.post(`/usersettings`, settings).then(res => {
            return resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

const UserSettingsApi = {
    getUserSettings,
    updateUserSettings,
    getTenantSettings
}

export default UserSettingsApi;